import React from "react";
import PropTypes from "prop-types";
import Skeleton from "../ui-components/Skeleton";

/**
 * Skeleton placeholder for the scope card during initial load.
 * Matches the real scope card layout to avoid layout shift.
 *
 * `bare` matches the shorter shape the scope takes inside a details panel: no card, no
 * heading placeholder, and only as many rows as that section actually renders.
 */
const SkeletonScopeCard = ({ bare }) => {
  if (bare) {
    return (
      <div className="space-y-2">
        <Skeleton className="h-4 w-3/4 rounded" />
        <Skeleton className="h-4 w-1/2 rounded" />
      </div>
    );
  }

  return (
    <section className="bg-card border border-card-bd rounded-card p-5">
      <Skeleton className="h-4 w-24 mb-3" />
      <div className="space-y-2 mt-4">
        <Skeleton className="h-8 w-full rounded" />
        <Skeleton className="h-8 w-full rounded" />
        <Skeleton className="h-8 w-3/4 rounded" />
        <Skeleton className="h-8 w-full rounded" />
        <Skeleton className="h-8 w-4/5 rounded" />
      </div>
      <Skeleton className="h-9 w-28 rounded mt-5" />
    </section>
  );
};

SkeletonScopeCard.propTypes = { bare: PropTypes.bool };

export default SkeletonScopeCard;
